import { useCallback, useContext, useEffect, useMemo, useState } from 'react'
import { TrainingItem } from '../../components/TrainingItem'
import { TrainingFragment } from '../../generated/urql.anonymous'
import { useI18n } from '../../provider/i18n'
import { BasketContext, isTrainingBasketItem } from '../../provider/basket'
import { trainingsSubscriptionAtom } from '../../store/subscription.atoms'
import { useAtomValue } from 'jotai'
import { TailSpin } from 'react-loader-spinner'
import { Blue300 } from '../../lib/colors'

const Trainings = () => {
  const [isInited, setIsInited] = useState(false)
  const basket = useContext(BasketContext)
  const i18n = useI18n()
  const [{ data: trainingsData, fetching: trainingsFetching }] = useAtomValue(
    trainingsSubscriptionAtom
  )

  const trainings = trainingsData?.training || []

  const isFetching = useMemo(
    () => trainingsFetching && !isInited,
    [trainingsFetching, isInited]
  )

  useEffect(() => {
    if (!isFetching) {
      setIsInited(true)
    }
  }, [isFetching])

  const onTrainingAddClick = useCallback(
    (training: TrainingFragment) => {
      basket.addItem({ training })
    },
    [basket]
  )

  if (isFetching) {
    return (
      <TailSpin
        color={Blue300}
        height={32}
        width={32}
        wrapperClass="flex justify-center p-8"
      />
    )
  }

  return (
    <>
      <div className="text-blue-700 my-5 flex items-center gap-1">
        {i18n.t('screens.catalog.index.trainings.header')}
      </div>
      <ul className="md:mx-5 flex flex-col gap-5 mb-10">
        {trainings.map((training) => (
          <li key={training.id}>
            <TrainingItem
              training={training}
              onTrainingAddClick={() => onTrainingAddClick(training)}
              showAddButton={
                !training.videoFile &&
                !basket.items.find(
                  (item) =>
                    isTrainingBasketItem(item) &&
                    training.id === item.training.id
                )
              }
            />
          </li>
        ))}
      </ul>
    </>
  )
}

export default Trainings
